export const formatRupiah = (amount) => {
  const formattedAmount = amount?.toLocaleString('id-ID', {
    style: 'currency',
    currency: 'IDR'
  });

  return formattedAmount?.replace('Rp', 'Rp.');
};

export function formatCurrency(amount: any, currency: string = 'IDR'): string {
  const value = Number(amount ?? 0);

  if (isNaN(value)) return 'Rp0,00';

  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2
  }).format(value);
}

export function formatNumberWithCommas(number: number): string {
  return number?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
export function formatNumberWithDot(number: number): string | number {
  return number?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

export function formatDate(inputDate: string): string {
  if (!inputDate) return '';

  const date = new Date(inputDate);
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  };

  const formattedDate = new Intl.DateTimeFormat('en-GB', options).format(date);

  return formattedDate;
}

export function formatOnlyDate(inputDate: string): string {
  if (!inputDate) return '';
  const date = new Date(inputDate);
  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  };

  const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);

  const [month, day, year] = formattedDate.split('/');
  const rearrangedDate = `${day}/${month}/${year}`;

  return rearrangedDate;
}

export function removeHTMLTags(input) {
  return input?.replace(/<[^>]*>/g, '');
}

export function limitText(text, limit) {
  if (text?.length <= limit) {
    return text;
  } else {
    return text.slice(0, limit) + '...';
  }
}

export function isObjectEmpty(obj: Record<string, any>): boolean {
  return Object.keys(obj)?.length === 0;
}

export function daysToMinutes(days: number): number {
  return days * 24 * 60;
}

export function minutesToDays(minutes: number): number {
  return minutes / (24 * 60);
}

export const formatTime = (dateString: string): string => {
  const date = new Date(dateString);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${hours}:${minutes}`;
};

export const formatWhatsAppDate = (dateString: string): string => {
  const date = new Date(dateString);
  const now = new Date();
  const diff = now.getTime() - date.getTime();
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));

  if (days === 0) {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  if (days === 1) {
    return 'Kemarin';
  }

  if (days < 7) {
    const daysOfWeek = [
      'Minggu',
      'Senin',
      'Selasa',
      'Rabu',
      'Kamis',
      'Jumat',
      'Sabtu'
    ];
    return daysOfWeek[date.getDay()];
  }

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();

  if (year === now.getFullYear()) {
    return `${day}/${month}`;
  }

  return `${day}/${month}/${year}`;
};

export const formatDisplayName = (name: string, fullWords = 2) => {
  if (!name) return '';
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length <= fullWords) return words.join(' ');
  const head = words.slice(0, fullWords).join(' ');
  const initials = words
    .slice(fullWords)
    .map((w) => (w ? `${w.charAt(0).toUpperCase()}.` : ''))
    .filter(Boolean)
    .join(' ');
  return `${head} ${initials}`;
};
